export var WasThisUsefulMode;
(function (WasThisUsefulMode) {
    WasThisUsefulMode[WasThisUsefulMode["None"] = 0] = "None";
    WasThisUsefulMode[WasThisUsefulMode["Yes"] = 1] = "Yes";
    WasThisUsefulMode[WasThisUsefulMode["No"] = 2] = "No";
    WasThisUsefulMode[WasThisUsefulMode["Sent"] = 3] = "Sent";
    WasThisUsefulMode[WasThisUsefulMode["Sending"] = 4] = "Sending";
})(WasThisUsefulMode || (WasThisUsefulMode = {}));
